// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2WbLb","question":"Question_question__1NsRk","description":"Question_description__1Ujxo"};